import { getPOBoxByUser } from "api/POBoxApi";
import { getPrices, getUserPrices } from "api/PriceApi";
import { getUserData } from "./Session";
import { getAddressOptions } from "./Utils";

export default {
    priceType: async () => {
        const prices = await getPrices();
        return prices.reduce((a, price) => {
            a[price.id] = price.name;
            return a;
        }, {});
    },
    userPriceList: async () => {
        const prices = await getUserPrices();
        return prices.reduce((a, price) => {
            a[price.id] = price.name;
            return a;
        }, {});
    },
    poBoxAddresses: async () => {
        let addressList = {};
        const userData = await getUserData();
        if (userData.id) {
            const poBox = await getPOBoxByUser(userData);
            const addresses = poBox.addresses?.items || [];
            addressList = getAddressOptions(addresses);

        }
        return addressList;
    }
}